module.exports = __webpack_public_path__ + "static/media/DINERS.6ddd4ef2.svg";